import {
  Button, Dropdown, Table, Tooltip,
} from "antd";
import {
  MoreOutlined, EditOutlined, DeleteOutlined,
} from "@ant-design/icons";
import React from "react";
import moment from "moment";
import { toTitleCase } from "../../../../utils/helpers";
import { getRegularTestName } from "../utils";
import { buildTestMenuItem } from "../qcRuleTableMenuItems";

export default function CustomerRulesTable({
  dataSource,
  loading,
  onRowClick,
  onEdit,
  onDelete,
  onTest,
  pagination = false,
}) {
  return (
    <Table
      rowKey={(rule) => rule._id}
      dataSource={dataSource}
      pagination={pagination}
      bordered
      rowHoverable
      loading={loading}
      className="CustomerRules_Table"
      onRow={(data) => ({
        onClick: () => onRowClick(data),
      })}
    >
      <Table.Column
        title="Customer Id"
        dataIndex="customer_id"
        key="customer_id"
      />
      <Table.Column
        title="Scope"
        key="scope"
        render={(_, record) => toTitleCase(record?.scope)}
      />
      <Table.Column
        title="Sample Info"
        key="sample_type"
        render={(_, record) => record?.sample_info?.sample_type}
      />
      <Table.Column
        title="Regular Tests"
        key="regular_tests"
        render={(_, record) => {
          const value = record?.sample_info?.regular_tests;
          if (!Array.isArray(value) || value.length === 0) return "-";
          const labels = value.map((spec) => getRegularTestName(spec)).filter(Boolean);
          return labels.length ? labels.join(", ") : "-";
        }}
      />
      <Table.Column
        title="QC Pointers"
        key="qc_pointers"
        render={(_, record) => record?.sample_info?.qc_pointers}
      />
      <Table.Column
        title="Specs"
        key="specs"
        render={(_, record) => record?.sample_info?.specs}
      />
      <Table.Column
        title="Created By"
        dataIndex="created_by"
        key="created_by"
        render={(value, data) => (
          <Tooltip title={data?.created_at ? moment(data.created_at).format("MM/DD/YYYY, h:mm:ss a") : ""}>
            <>{value}</>
          </Tooltip>
        )}
      />
      <Table.Column
        title="Updated By"
        dataIndex="updated_by"
        key="updated_by"
        render={(value, data) => (
          <Tooltip title={data?.updated_at ? moment(data.updated_at).format("MM/DD/YYYY, h:mm:ss a") : ""}>
            <>{value}</>
          </Tooltip>
        )}
      />
      <Table.Column
        title="Action"
        render={(_, record) => (
          <Dropdown
            menu={{
              items: [
                {
                  key: "edit",
                  label: "Edit",
                  icon: <EditOutlined />,
                  onClick: (e) => {
                    e.domEvent.preventDefault();
                    e.domEvent.stopPropagation();
                    onEdit(record);
                  },
                },
                buildTestMenuItem(record, onTest),
                {
                  key: "delete",
                  label: "Delete",
                  icon: <DeleteOutlined />,
                  onClick: (e) => {
                    e.domEvent.preventDefault();
                    e.domEvent.stopPropagation();
                    onDelete(record);
                  },
                },
              ],
            }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button
              type="text"
              size="medium"
              icon={<MoreOutlined />}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          </Dropdown>
        )}
      />
    </Table>
  );
}
